import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import {
  FormControlStyles,
  StyledSelect,
  StyledMenuItem,
  ComboBoxContainer,
  AddButton,
  MenuProps
} from './general-combo-box.styles';
import { HealthClaim } from '../../../types';
import { HEALTH_CLAIMS_LOW } from './health-claims-panel';
import { ComboBoxProps } from './panel-types';

interface HealthClaimsComboBoxProps extends ComboBoxProps {
  values: HealthClaim[];
}

const HEALTH_CLAIMS_TITLE: string = 'Add health claim';

export function HealthClaimsComboBox(props: HealthClaimsComboBoxProps) {
  const [selectedValue, setSelectedValue] = useState(HEALTH_CLAIMS_TITLE);
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedValue(event.target.value as string);
  };

  function clickHandler() {
    if (props.valueAddedHandler && selectedValue !== HEALTH_CLAIMS_TITLE) {
      props.valueAddedHandler(selectedValue);
      setSelectedValue(HEALTH_CLAIMS_TITLE);
    }
  }

  return (
    <FormControlStyles size='small'>
      <ComboBoxContainer id={`${HEALTH_CLAIMS_LOW}-combo-box-container`}>
        <StyledSelect
          id={`${HEALTH_CLAIMS_LOW}-select`}
          value={selectedValue}
          onChange={handleChange}
          MenuProps={MenuProps}
        >
          <StyledMenuItem id={`${HEALTH_CLAIMS_LOW}-menu`} value={HEALTH_CLAIMS_TITLE} disabled>
            {HEALTH_CLAIMS_TITLE}
          </StyledMenuItem>
          {props.values.map((val) => (
            <StyledMenuItem id={`${val.key}-item`} key={val.key} value={val.displayName}>
              {val.displayName}
            </StyledMenuItem>
          ))}
        </StyledSelect>
        <AddButton id={`${HEALTH_CLAIMS_LOW}-add-button`} onClick={clickHandler}>
          Add
        </AddButton>
      </ComboBoxContainer>
    </FormControlStyles>
  );
}
